import { ReactNode } from 'react'
import { Spacer } from '@vinted/web-ui'

import { SeparatedList } from '@marketplace-web/common-components/separated-list-ui'

import ResponsiveWrapper from '../../ReponsiveWrapper'

type Props = {
  children: Array<ReactNode>
}

const FactsSection = ({ children }: Props) => (
  <section>
    <div className="page-section__facts">
      <SeparatedList
        separator={
          <ResponsiveWrapper
            mobile={<Spacer size={Spacer.Size.X2Large} />}
            desktop={
              <Spacer size={Spacer.Size.X2Large} orientation={Spacer.Orientation.Vertical} />
            }
          />
        }
      >
        {children}
      </SeparatedList>
    </div>
    <ResponsiveWrapper
      mobile={<Spacer size={Spacer.Size.X2Large} />}
      desktop={<Spacer size={Spacer.Size.X4Large} />}
    />
  </section>
)

export default FactsSection
